import MessageConversation from '@efdigital/ll-xceed-v2/components/coaching/messaging/message-conversation.gts';
import type { CoachingCoacheeCohortMessagesConversationModel } from '@efdigital/ll-xceed-v2/routes/coaching/coachee/cohort/messages/conversation';
import type { TOC } from '@ember/component/template-only';

interface MessagesConversationSignature {
  Args: {
    model: CoachingCoacheeCohortMessagesConversationModel;
    controller: unknown;
  };
}

<template>
  <MessageConversation
    @conversation={{@model.conversation}}
    @role="coachee"
    @programId={{@model.program_id}}
    @cohortId={{@model.cohort_id}}
    class="h-100 w-100"
  />
</template> satisfies TOC<MessagesConversationSignature>;
